import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    backgroundColor: 'rgb(255, 255, 255)',
    borderTopColor: 'rgba(34, 197, 94, 0.2)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-156">
      <div className="mx-auto max-w-4xl text-center" data-id="element-157">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-green-700" data-id="element-158">
          👶 CONSTRUYE PROGRESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-159">
          El sistema N°1 para madres que quieren estimular el desarrollo de su hijo con criterio, confianza y sin improvisar.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-160">
          "Porque los primeros 3 años no se repiten — y tu hijo merece que los aproveches al máximo."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-161">
          <a href="mailto:construyeprogresoo@gmail.com" className="no-underline text-gray-600 hover:text-green-700 transition-colors" data-id="element-162">
            📧 construyeprogresoo@gmail.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-163">|</span>
          <span className="text-gray-600" data-id="element-164">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-200" data-id="element-165">|</span>
          <a href="https://www.construyeprogreso.com" target="_blank" rel="noopener noreferrer" className="no-underline text-gray-600 hover:text-green-700 transition-colors" data-id="element-166">
            🌐 www.construyeprogreso.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24 bg-green-700/30" data-id="element-167" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-168">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-169">
            © {new Date().getFullYear()} Construye Progreso™ — Todos los derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-170">
            Prohibida la reproducción total o parcial y la redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}